import React, {
  Component
} from "react";
import {
  connect
} from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import {
  withStyles
} from "@material-ui/core/styles";
// import Drawer from '@material-ui/core/Drawer';
import CssBaseline from "@material-ui/core/CssBaseline";
import HeaderMenu from "components/Header/HeaderMenu";
import ThemeProvider from "components/Theme";
import Home from "components/Home/Home";
// import HomeMyEvents from "components/Home/HomeMyEvents";
// import Lives from "components/Lives/Lives";
import LivePlayer from "components/UI/Orchestrator/LivePlayerOrchestrator";
import Replays from "components/Replays/Replays";
import ReplayPlayer from 'components/Replays/ReplayPlayer';
import Contact from "components/Contact/Contact";
import Login from "components/Login/Login";
import Help from "components/Help/Help";
// import Agenda from 'components/Agenda/Agenda';
import Account from "components/Account/Account";
import Files from "components/UI/Files/Files";
import AdminAccount from "components/UI/Account/AdminAccount";
import AdminEvent from "components/UI/Event/AdminEvent";
import AdminNews from "components/UI/News/AdminNews";
import AdminFaq from "components/UI/Faq/AdminFaq";
import AdminCMS from "components/UI/Cms/AdminCms";
import AdminTheme from "components/UI/Theme/AdminTheme";
import AdminMessage from "components/UI/Message/AdminMessage";
import ScrollToTopOnMount from "components/UI/ScrollToTopOnMount";
import NoMatch from "components/NoMatch";
import Logout from "components/Logout";
import Legal from "components/Legal/Legal";
import Confidentiality from "components/Confidentiality/Confidentiality";
import Registration from 'components/Registration/Registration';

// import WrapperQuiz from "components/UI/Quiz/WrapperQuiz";
// import Orchestrator from "components/UI/Orchestrator/Orchestrator";
import DetectBrowser from 'components/UI/DetectBrowser/DetectBrowser'
import Feedback from "components/UI/Feedback/WrapperFeedback";
import AdminFeedback from "components/UI/Feedback/AdminFeedback";
import AdminOrchestrator from "components/UI/Orchestrator/AdminOrchestrator";
import AdminOrchestratorIndex from "components/UI/Orchestrator/AdminOrchestratorIndex";
import AdminQuiz from "components/UI/Quiz/AdminQuiz";
import AdminUtm from "components/UI/Utm/AdminUtm";
import {
  ResetPasswordRequest,
  ResetPasswordChallenge,
} from "components/UI/ResetPassword";
import queryString from "query-string";
import {
  login as initialeLogin,
  isStateKnown as authStateKnown,
  getCurrentUserRole,
  // isLoggedIn,
} from "../ducks/authentication";
import "../App.css";
import capitalize from "lodash/capitalize";
const styles = {
  // drawerPaper: {
  //   top: 40,
  //   zIndex: 998,
  //   borderRadius: '0 0 5px 5px',
  //   padding: '5px 3px'
  // },
  // drawerModal: {
  //   zIndex: 997,
  // }
  root: {
    height: "100%",
  },
};
class App extends Component {
  componentDidMount() {
    document.title = process.env.REACT_APP_SITE_TITLE ? process.env.REACT_APP_SITE_TITLE : "Canal " + capitalize(process.env.REACT_APP_SITE);
    this.props.onMount();
  }
  render() {
    const {
      // loggedIn,
      userRole,
      authStateKnown,
      classes,
      // width,
      // $$data
    } = this.props;
    return (<div className={classes.root}>
        <ThemeProvider>
          <CssBaseline />
          <ScrollToTopOnMount />
            <DetectBrowser/>
          <If condition={authStateKnown === true}>
            <Router>
              <Switch>
                <Route
                  exact={true}
                  path={"/"}
                  component={({ match }) => <Home />}
                />
                <Route
                  exact={true}
                  path={"/subscribe/:id"}
                  component={({ match }) => (
                    <Home subscribe={true} themeId={match.params.id} />
                  )}
                />
                {/*<Route exact={true} path={'/subscribe'} component={({match}) => (<Home subscribe={true}/>)}/>*/}
                <Route
                  exact={true}
                  path={"/help"}
                  component={({ match }) => <Help />}
                />
                <Route
                  exact={true}
                  path={"/contact"}
                  component={({ match }) => <Contact />}
                />
                <Route path={"/legal"} component={() => <Legal />} />
                <Route
                  path={"/confidentiality"}
                  component={() => <Confidentiality />}
                />
                <Route
                  exact={true}
                  path={"/live/:id"}
                  component={({ match }) => (
                    <LivePlayer
                      match={match}
                      onPanelToggle={this._panelToggle}
                    />
                  )}
                />
                <Route path={'/replays/:id'} component={({ match }) => <ReplayPlayer match={match} />} />
                <Route path={'/replays'} component={({ match }) => <Replays />} />

              {/*    <Route
                  exact={true}
                  path={"/live"}
                  component={({ match }) => <Lives />}
                />*/}
                <Route
                  exact={true}
                  path={"/login"}
                  component={({ match }) => <Login />}
                />
                <Route
                  exact={true}
                  path={"/logout"}
                  component={() => <Logout />}
                />
                <Route
                  path="/rpwd"
                  component={() => <ResetPasswordRequest showBtCancel={false} onCancel='gotoHome'/>}
                />
                <Route
                  path="/cpwd"
                  component={() => <ResetPasswordChallenge />}
                />

                <Route
                  path="/staff/account/:action/:id"
                  component={({ match }) => <AdminAccount match={match} />}
                />
                <Route
                  path="/staff/account/:action"
                  component={({ match }) => <AdminAccount match={match} />}
                />
                <Route
                  path="/staff/account"
                  component={() => <AdminAccount />}
                />

                <Route
                  path="/staff/event/:action/:id"
                  component={({ match }) => <AdminEvent match={match} />}
                />
                <Route
                  path="/staff/event/:action"
                  component={({ match }) => <AdminEvent match={match} />}
                />
                <Route path="/staff/event" component={() => <AdminEvent />} />

                <Route
                  path="/staff/news/:action/:id"
                  component={({ match }) => <AdminNew match={match} />}
                />
                <Route
                  path="/staff/news/:action"
                  component={({ match }) => <AdminNews match={match} />}
                />

                <Route
                  path="/staff/utm/:action/:id"
                  component={({ match }) => <AdminUtm match={match} />}
                  />
                <Route path="/staff/utm/:action" component={({ match }) => <AdminUtm match={match} />} />
                <Route path="/staff/utm" component={() => <AdminUtm />} />

                <Route
                  path="/staff/faq/:action/:id"
                  component={({ match }) => <AdminFaq match={match} />}
                />
                <Route
                  path="/staff/faq/:action"
                  component={({ match }) => <AdminFaq match={match} />}
                />

                <Route
                  path="/staff/theme/:action/:id"
                  component={({ match }) => <AdminTheme match={match} />}
                />
                <Route
                  path="/staff/theme/:action"
                  component={({ match }) => <AdminTheme match={match} />}
                />

                <Route
                  path="/staff/cms/:action/:id"
                  component={({ match }) => <AdminCMS match={match} />}
                />
                <Route
                  path="/staff/cms/:action"
                  component={({ match }) => <AdminCMS match={match} />}
                />

                <Route
                  path="/staff/message/:action/:id"
                  component={({ match }) => <AdminMessage match={match} />}
                />
                <Route
                  path="/staff/message/:action"
                  component={({ match }) => <AdminMessage match={match} />}
                />
                <Route exact path={'/registration'} component={({ match }) => <Registration />} />

                <Route path="/staff/feedback/:eventId/:action/:id" component={({match}) => <AdminFeedback match={match}/>}/>
                <Route path="/staff/feedback/:eventId/:action" component={({match}) => <AdminFeedback match={match}/>}/>
                  <Route path="/feedback/:eventId" component={({match}) => <Feedback match={match}/>}/>

                <Route exact path={"/staff/quiz/:eventId/:action/:id"} component={({ match }) => <AdminQuiz match={match}/>} />
                <Route exact path={"/staff/quiz/:eventId/:action"} component={({ match }) => <AdminQuiz match={match}/>} />

                <Route exact path={"/staff/orchestrator/:eventId/:action"} component={({ match }) => <AdminOrchestrator match={match}/>} />
                <Route exact path={"/staff/orchestrator/list"} component={({ match }) => <AdminOrchestratorIndex match={match}/>} />

                <Route path="/account" component={() => <Account />} />
                  <Route path="/files" component={() =><Files/>}/>
                <Route component={() => <NoMatch />} />
              </Switch>
            </Router>
          </If>
        </ThemeProvider>
      </div>);
  }
}

function mapStateToProps(state) {
  const props = {
    authStateKnown: authStateKnown(state),
    // loggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      const uri = queryString.parse(window.location.search);
      return dispatch(initialeLogin({
        referer: uri.r
      }));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/components/App.js